/**
 * Fila de toasts e o hook que a alimenta.
 *
 * Fora de `Toast.tsx` porque aquele arquivo so pode exportar componentes: um store e um
 * hook no mesmo modulo derrubam o Fast Refresh dele inteiro
 * (react-refresh/only-export-components).
 */
import { create } from 'zustand'
import type { Toast } from './toastTypes'

interface ToastStore {
  toasts: Toast[]
  addToast: (toast: Omit<Toast, 'id'>) => void
  removeToast: (id: string) => void
}

export const useToastStore = create<ToastStore>((set) => ({
  toasts: [],
  addToast: (toast) =>
    set((state) => ({
      toasts: [
        ...state.toasts,
        { ...toast, id: crypto.randomUUID(), duration: toast.duration ?? 5000 },
      ],
    })),
  removeToast: (id) =>
    set((state) => ({
      toasts: state.toasts.filter((t) => t.id !== id),
    })),
}))

export const useToast = () => {
  const { addToast } = useToastStore()
  return {
    toast: (title: string, description?: string) =>
      addToast({ title, description, variant: 'default' }),
    success: (title: string, description?: string) =>
      addToast({ title, description, variant: 'success' }),
    error: (title: string, description?: string) =>
      addToast({ title, description, variant: 'error' }),
    message: (title: string, description?: string, action?: Toast['action']) =>
      addToast({ title, description, variant: 'message', action }),
  }
}
